import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import EditPanel from '../../../components/Editor/EditPanel';
import { PdfImportingStatus } from '../constants';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			editPanel: { x, y },
			activeItem: { id },
			settings: { pdfImportingStatus },
		},
	} = state;

	return {
		x,
		y,
		activeItemId: id,
		isDisabled: pdfImportingStatus === PdfImportingStatus.PROCESSING,
	};
};

export default connect(mapStateToProps)(EditPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/index.tsx